module.exports = __webpack_public_path__ + "static/media/vitalRegistration.6e83af06.png";